import React from "react";
import "./CrewMember.css";

const CrewMember = ({ profilePictureUrl, primaryText, secondaryText, id }) => (
  <a
    href={`https://www.themoviedb.org/person/${id}`}
    target="_blank"
    className="crew-member"
  >
    <div className="crew-member-picture">
      <img
        src={
          profilePictureUrl
            ? `https://image.tmdb.org/t/p/w92${profilePictureUrl}`
            : "https://popcornusa.s3.amazonaws.com/placeholder-movieimage.png"
        }
      />
    </div>
    <div className="primary">{primaryText}</div>
    <div className="secondary">{secondaryText}</div>
  </a>
);

export default CrewMember;



// WEBPACK FOOTER //
// ./src/components/CrewMember.tsx